import { css } from "@emotion/css";
import { text, themeTokens } from "@octopusdeploy/design-system-tokens";
const styles = {
    label: css({
        font: text.body.regular.xSmall,
        color: themeTokens.color.text.tertiary,
    }),
};
export const FilterObjectCounter = (props: {
    total: number;
    filteredTotal: number;
    objectLabel: string;
}) => props.total > props.filteredTotal && props.filteredTotal > 0 ? (<div aria-label="Filter Counter">
            <span className={styles.label}>
                {props.filteredTotal} of {props.total} {props.objectLabel} match your filters
            </span>
        </div>) : null;
